import client from './client.js';

export const searchLabs = async ({ tussCodes, cep, radiusKm = 5 }) => {
  const params = new URLSearchParams({ cep, radius_km: radiusKm });
  tussCodes.forEach((c) => params.append('tuss_codes', c));
  const { data } = await client.get(`/labs/search?${params}`);
  return data;
  // Array de { partner_id, trade_name, address, city, state, distance_km, rating, hours_json, prices: [{tuss_code, price}] }
};

export const searchTuss = async (q) => {
  const { data } = await client.get(`/labs/tuss/search?q=${encodeURIComponent(q)}`);
  return data;
};

// Catálogo público (sem login) — exames com menor preço entre os parceiros
export const getCatalog = async ({ q, limit } = {}) => {
  const params = new URLSearchParams();
  if (q) params.set('q', q);
  if (limit) params.set('limit', limit);
  const { data } = await client.get(`/labs/catalog?${params}`);
  return data;
  // Array de { code, name, price }
};

// Nenhum laboratório faz todos os exames: combinações de 1 a 3 laboratórios,
// priorizando todos os exames de sangue no mesmo lugar (uma coleta só).
export const searchLabCombinations = async ({ tussCodes, cep }) => {
  const params = new URLSearchParams();
  if (cep) params.set('cep', cep);
  tussCodes.forEach((c) => params.append('tuss_codes', c));
  const { data } = await client.get(`/labs/search/combinations?${params}`);
  return data;
  // { missing: [{tuss_code, tuss_name}], blood_codes: [...], combinations: [{ total, lab_count, blood_together, has_blood, labs: [{ partner, subtotal, exams: [{tuss_code, tuss_name, price, is_blood}] }] }] }
};
